import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    api_url = environment.url;

    constructor(private http: HttpClient) { }
    statsServices() {
        return this.http.get(`${this.api_url}dashboard/stats_services`)
    }
}
